<template>
    <div>
        <!-- Main Bg Gradient -->
        <div class="w-screen h-dvh max-w-full max-h-full landing flex flex-col justify-center items-center">
            <!-- Content -->
            <div class="flex flex-col justify-around sm:justify-center items-center gap-10 w-full md:w-[600px] text-center py-4 px-10 overflow-x-hidden overflow-y-auto h-full">
                <div class="flex flex-col gap-5 justify-center items-center">
                    <GeneralCoachMarble class="h-[60px] w-[60px]" />
                    <div class="flex md:flex-row flex-col">
                        <!-- Title -->
                        <template v-if="!isOutro">
                            <span class="display-serif text-[#262626]">Hi I'm Nadia,&nbsp;</span>
                            <span class="display-serif text-[#262626]">{{ recipient_users_name }}'s AI Coach</span>
                        </template>
                        <template v-else>
                            <span class="text-[48px]">Thanks for your time</span>
                        </template>
                    </div>
                    <template v-if="!isOutro">
                        <div class="body-small text-[#262626] text-left w-full">
                            {{ recipient_users_name }} is looking for some quick feedback on how they're doing as a teammate and leader. They've asked me to help collect some
                            insights from the people they work with.
                        </div>
                    </template>
                    <template v-else>
                        <div class="body-small text-[#262626] text-left mx-auto">
                            This feedback will be combined with other team<br />
                            members' feedback to create a report for {{ recipient_users_name }}.
                        </div>
                    </template>
                    <template v-if="!isOutro">
                        <div class="flex flex-wrap gap-2.5 text-[#262626] justify-center items-center">
                            <div class="w-[150px] md:h-[150px] h-20 flex flex-col justify-center md:justify-start items-center md:pt-11 px-2 bg-white/[.28] rounded-2xl">
                                <i class="bi bi-shield-lock" aria-hidden="true"></i>
                                <div class="body-small">Anonymous</div>
                            </div>
                            <div class="w-[150px] md:h-[150px] h-20 flex flex-col justify-center md:justify-start items-center md:pt-11 px-2 bg-white/[.28] rounded-2xl">
                                <i class="bi bi-clock" aria-hidden="true"></i>
                                <div class="body-small">2 minutes</div>
                            </div>
                            <div class="w-[150px] md:h-[150px] h-20 flex flex-col justify-center md:justify-start items-center md:pt-11 px-2 bg-white/[.28] rounded-2xl">
                                <i class="bi bi-journal-text" aria-hidden="true"></i>
                                <div class="body-small">
                                    Speak naturally,<br />
                                    I'll synthesize
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="w-[150px] md:h-[150px] h-20 flex flex-col justify-center items-center py-2.5 bg-white/[.28] rounded-2xl">
                            <i class="bi bi-check-circle text-base" aria-hidden="true"></i>
                            <p class="body">Sent</p>
                        </div>
                    </template>
                </div>
                <template v-if="!isOutro">
                    <BaseButton :disabled="preview" theme="primary" class="w-[300px]" @click="startChat">Share feedback</BaseButton>
                </template>
                <template v-else>
                    <BaseButton theme="primary" class="w-[300px]" @click="openUrl('/accounts/login/')">Login to Nadia</BaseButton>
                </template>
            </div>
            <!-- Start of perceived footer -->
            <div v-if="!preview" class="hidden sm:block">
                <div class="grid grid-cols-3 gap-4 items-center mt-8 md:my-6 md:w-[60vw]">
                    <div>
                        <PrivacyDialog />
                    </div>
                    <div class="flex text-center justify-center items-center w-full gap-x-2">
                        <p class="gradient-text body-small-bold inline">Made by</p>
                        <img :src="ColorLogo" alt="logo" class="h-6 w-auto" />
                    </div>
                    <form class="flex flex-col gap-5 items-center">
                        <div class="gap-10 flex items-center justify-center">
                            <select
                                aria-label="language"
                                class="focus-visible:outline-hidden bg-transparent shrink-0 inline-block w-auto hover:text-[#7C7C7C] text-valence-grey-750 body-small">
                                <template v-for="opt in languageOptions" :key="opt[0]">
                                    <option :value="opt[0]" :selected="opt[0] === 'English'" v-text="opt[0]"></option>
                                </template>
                            </select>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import ColorLogo from "~img/color-logo.svg";
import BaseButton from "~vue/components/BaseButton.vue";
import GeneralCoachMarble from "~vue/components/navigation/CoachingModeMarbles/GeneralCoachMarble.vue";
import PrivacyDialog from "~vue/Onboarding/PrivacyDialog.vue";
import { openUrl } from "~vue/utils";
import { inject } from "vue";

defineProps({
    preview: {
        type: Boolean,
        default: false,
    },
    recipient_users_name: {
        type: String,
        default: "",
    },
    isOutro: {
        type: Boolean,
        default: false,
    },
});

const startChat = () => {
    emit("start-feedback-flow");
};
const emit = defineEmits(["start-feedback-flow"]);

const languageOptions = inject("languageOptions");
</script>

<style scoped>
.landing {
    background-color: rgba(234, 184, 150, 0.6);
    background-image: linear-gradient(150deg, transparent 50%, rgba(234, 184, 150, 1) 90%), linear-gradient(230deg, transparent 65%, rgba(200, 158, 247, 1));
}
</style>
